import { Screen } from '~/screens/top-banners';

export const TopBannersIndex: React.FC = () => <Screen />;
